import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

function ThreeWealthyJars() {
  const frame = useRef(null);
  const [height, setHeight] = useState(1800);

  useEffect(() => {
    const resize = (event) => {
      if (event.origin !== window.location.origin || event.source !== frame.current?.contentWindow) return;
      if (event.data?.type !== 'wealthycats:jars-height') return;
      const next = event.data.height;
      if (Number.isFinite(next) && next > 0) setHeight(Math.max(600, Math.ceil(next)));
    };
    window.addEventListener('message', resize);
    return () => window.removeEventListener('message', resize);
  }, []);

  return (
    <main className="pt-24 bg-[#eef6f5]">
      <div className="container-custom py-4 flex flex-wrap justify-between gap-3 text-sm">
        <Link to="/tools" className="text-gray-700 underline underline-offset-4">← Financial Planning Tools</Link>
        <a href="/tool-backups/three-wealthy-jars/" target="_blank" rel="noopener noreferrer" className="text-gray-700 underline underline-offset-4">Open tool in a new tab</a>
      </div>
      <iframe ref={frame} src="/tool-backups/three-wealthy-jars/" title="The 3 Wealthy Jars financial planning simulator" className="w-full border-0 block" style={{ height }} />
    </main>
  );
}

export default ThreeWealthyJars;
